import { Spinner } from '@fluentui/react-components';
import React, { FC } from 'react';

export const AssignmentsWidgetSkeleton: FC = () => {
  return (
    <div className="assignmentsWidgetSkeleton">
      <Spinner />
    </div>
  );
};
